import { Chip, Stack } from "@mui/material";

/**
 * SummaryBar - Displays filter chips with status counts
 * Allows users to filter comparison results by status type
 *
 * @component
 * @param {Object} props
 * @param {Array} props.rows - Comparison result rows
 * @param {string} props.filter - Current filter type
 * @param {Function} props.onFilter - Callback when filter changes
 * @returns {JSX.Element} Filter chip bar
 */
export function SummaryBar({
  rows,
  filter,
  onFilter,
  leftSource,
  rightSource,
}) {
  const counts = rows.reduce((acc, r) => {
    acc[r.status] = (acc[r.status] ?? 0) + 1;
    return acc;
  }, {});

  const items = [
    { key: "all", label: "All", n: rows.length, color: "default" },
    { key: "match", label: "Match", n: counts.match ?? 0, color: "success" },
    {
      key: "mismatch",
      label: "Mismatch",
      n: counts.mismatch ?? 0,
      color: "error",
    },
    {
      key: "left-only",
      label: leftSource?.type + " Only",
      n: counts["left-only"] ?? 0,
      color: "warning",
    },
    {
      key: "right-only",
      label: rightSource?.type + " Only",
      n: counts["right-only"] ?? 0,
      color: "info",
    },
  ];

  return (
    <Stack direction="row" gap={1} flexWrap="wrap">
      {items.map(({ key, label, n, color }) => (
        <Chip
          key={key}
          label={`${label} (${n})`}
          size="small"
          color={color}
          variant={filter === key ? "filled" : "outlined"}
          onClick={() => onFilter(key)}
          sx={{ cursor: "pointer", fontWeight: 600, fontSize: "0.72rem" }}
        />
      ))}
    </Stack>
  );
}
